export const FETCH_RECENT_TICKETS = "FETCH_RECENT_TICKETS"
export const POST_CUSTOMER_CREATION_TICKET = "POST_CUSTOMER_CREATION_TICKET"
export const FETCH_CUSTOMERS = "FETCH_CUSTOMERS"
export const INTERNAL_UPDATE_CUSTOMER = "INTERNAL_UPDATE_CUSTOMER"
export const RECEIVE_RECENT_TICKETS = "RECEIVE_RECENT_TICKETS"
export const RECEIVE_CUSTOMERS = "RECEIVE_CUSTOMERS"
export const DELETE_CUSTOMER = "DELETE_CUSTOMER"
export const CHECK_IF_CUSTOMER_EXISTS = "CHECK_IF_CUSTOMER_EXISTS"
export const SET_PING_COUNT = "SET_PING_COUNT"
export const INCREMENT_PING_COUNT = "INCREMENT_PING_COUNT"

export const fetchRecentTickets = () => ({
  type: FETCH_RECENT_TICKETS,
})

export const setPingCount = (pingCount) => ({
  type: SET_PING_COUNT,
  pingCount,
})

export const incrementPingCount = () => ({
  type: INCREMENT_PING_COUNT,
})

export const checkIfCustomerExists = (success, error) => ({
  type: CHECK_IF_CUSTOMER_EXISTS,
  success,
  error,
})

export const postCustomerCreationTicket = (params, success) => ({
  type: POST_CUSTOMER_CREATION_TICKET,
  params,
  success,
})

export const fetchCustomers = (success, error) => ({
  type: FETCH_CUSTOMERS,
  success,
  error,
})

export const deleteCustomer = (success, error) => ({
  type: DELETE_CUSTOMER,
  success,
  error,
})

export const internalUpdateCustomer = (customerId, params, success, error) => ({
  type: INTERNAL_UPDATE_CUSTOMER,
  customerId,
  params,
  success,
  error,
})

export const receiveRecentTickets = (recentTickets) => ({
  type: RECEIVE_RECENT_TICKETS,
  recentTickets,
})

export const receiveCustomers = (customers) => ({
  type: RECEIVE_CUSTOMERS,
  customers,
})
